import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

// Landing page for the Microsoft sign-in redirect: the backend hands us a short-lived
// access token in the URL after verifying the Microsoft account server-side. We pick it
// up once, then immediately scrub it from the address bar/history.
export default function MicrosoftComplete() {
  const [params] = useSearchParams();
  const { completeMicrosoftLogin } = useAuth();
  const navigate = useNavigate();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get("token");
    window.history.replaceState({}, "", "/auth/microsoft/complete");
    if (!token) {
      navigate("/login", { replace: true });
      return;
    }
    completeMicrosoftLogin(token)
      .then(() => navigate("/workspace", { replace: true }))
      .catch(() => {
        toast.error("Microsoft sign-in didn't complete. Please try again.");
        navigate("/login", { replace: true });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950">
      <p className="text-sm text-slate-400">Signing you in…</p>
    </div>
  );
}
